/* =========================================================
   AFAZEEN — global interactions
   ========================================================= */
(function () {
  'use strict';

  /* ---------- Header scroll / mobile menu / search ---------- */
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 40) header.classList.add('is-scrolled');
      else header.classList.remove('is-scrolled');
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  var menuToggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.querySelector('[data-mobile-menu]');
  var menuBackdrop = document.querySelector('[data-mobile-menu-backdrop]');
  function closeMenu() {
    if (mobileMenu) mobileMenu.classList.remove('is-open');
    document.body.classList.remove('menu-open');
  }
  function toggleMenu() {
    if (!mobileMenu) return;
    var willOpen = !mobileMenu.classList.contains('is-open');
    mobileMenu.classList.toggle('is-open', willOpen);
    document.body.classList.toggle('menu-open', willOpen);
  }
  if (menuToggle) menuToggle.addEventListener('click', toggleMenu);
  if (menuBackdrop) menuBackdrop.addEventListener('click', closeMenu);

  var searchToggles = document.querySelectorAll('[data-search-toggle]');
  var searchPanel = document.querySelector('[data-search-panel]');
  var searchClose = document.querySelector('[data-search-close]');
  function toggleSearch(force) {
    if (!searchPanel) return;
    var willOpen = typeof force === 'boolean' ? force : !searchPanel.classList.contains('is-open');
    searchPanel.classList.toggle('is-open', willOpen);
    if (willOpen) {
      var input = searchPanel.querySelector('input[type="search"], input[type="text"]');
      if (input) setTimeout(function () { input.focus(); }, 150);
    }
  }
  searchToggles.forEach(function (btn) { btn.addEventListener('click', function () { toggleSearch(); }); });
  if (searchClose) searchClose.addEventListener('click', function () { toggleSearch(false); });

  /* ---------- Predictive search ---------- */
  var predictiveInput = document.querySelector('[data-predictive-search-input]');
  var predictiveResults = document.querySelector('[data-predictive-search-results]');
  var predictiveTimer;
  if (predictiveInput && predictiveResults) {
    predictiveInput.addEventListener('input', function () {
      var q = predictiveInput.value.trim();
      clearTimeout(predictiveTimer);
      if (q.length < 2) { predictiveResults.innerHTML = ''; return; }
      predictiveTimer = setTimeout(function () {
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) { predictiveResults.innerHTML = ''; return; }
            var html = '<ul class="predictive-list">' + products.map(function (p) {
              var img = p.featured_image ? p.featured_image.url : '';
              return '<li><a href="' + p.url + '" class="predictive-item">' +
                (img ? '<img src="' + img + '" alt="" width="44" height="44">' : '') +
                '<span><span class="predictive-item-title">' + p.title + '</span>' +
                '<span class="predictive-item-price">' + (p.price ? p.price_formatted || '' : '') + '</span></span>' +
                '</a></li>';
            }).join('') + '</ul>';
            predictiveResults.innerHTML = html;
          })
          .catch(function () {});
      }, 250);
    });
  }

  /* ---------- Wishlist (local, persisted) ---------- */
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('afazeen_wishlist') || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem('afazeen_wishlist', JSON.stringify(list)); } catch (e) {}
  }
  function refreshWishlistButtons() {
    var list = getWishlist();
    document.querySelectorAll('[data-wishlist-toggle]').forEach(function (btn) {
      var id = btn.getAttribute('data-wishlist-toggle');
      btn.classList.toggle('is-active', list.indexOf(id) !== -1);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    var id = btn.getAttribute('data-wishlist-toggle');
    var list = getWishlist();
    var idx = list.indexOf(id);
    if (idx === -1) list.push(id); else list.splice(idx, 1);
    setWishlist(list);
    refreshWishlistButtons();
  });
  refreshWishlistButtons();

  /* ---------- Cart drawer ---------- */
  var cartDrawer = document.querySelector('[data-cart-drawer]');
  var cartOverlay = document.querySelector('[data-cart-drawer-overlay]');
  var cartTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  var cartClosers = document.querySelectorAll('[data-cart-drawer-close]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }
  cartTriggers.forEach(function (btn) { btn.addEventListener('click', function (e) {
    if (cartDrawer) { e.preventDefault(); openCartDrawer(); }
  }); });
  cartClosers.forEach(function (btn) { btn.addEventListener('click', closeCartDrawer); });
  if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartDrawer(cart) {
    if (!cartDrawer) return;
    var body = cartDrawer.querySelector('[data-cart-drawer-body]');
    var foot = cartDrawer.querySelector('[data-cart-drawer-foot]');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="cart-drawer-empty"><p>Your bag is empty.</p></div>';
      if (foot) foot.style.display = 'none';
      updateCartCount(0);
      return;
    }
    if (foot) foot.style.display = '';
    body.innerHTML = cart.items.map(function (item) {
      return '<div class="cart-line" data-cart-line="' + item.key + '">' +
        '<div class="cart-line-media"><img src="' + (item.image || '') + '" alt="" width="88" height="104"></div>' +
        '<div class="cart-line-info">' +
        '<p class="title">' + item.product_title + '</p>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="variant">' + item.variant_title + '</p>' : '') +
        '<div class="cart-line-foot">' +
        '<div class="cart-line-qty">' +
        '<button type="button" data-cart-qty-decrease>&minus;</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-cart-qty-increase>&plus;</button>' +
        '</div>' +
        '<span class="cart-line-price">' + formatMoney(item.final_line_price) + '</span>' +
        '</div>' +
        '<button type="button" class="cart-line-remove" data-cart-line-remove>Remove</button>' +
        '</div></div>';
    }).join('');
    var subtotalEl = cartDrawer.querySelector('[data-cart-subtotal]');
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    updateCartCount(cart.item_count);
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return (window.Shopify && window.Shopify.currency ? window.Shopify.currency.active + ' ' : '$') + amount;
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  function refreshCartUI() {
    fetchCart().then(renderCartDrawer).catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var submitBtn = form.querySelector('[type="submit"]');
    var originalText = submitBtn ? submitBtn.textContent : '';
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Adding…'; }
    var formData = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (submitBtn) submitBtn.textContent = 'Added to Bag';
        refreshCartUI();
        openCartDrawer();
        setTimeout(function () {
          if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
        }, 2200);
      })
      .catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalText; }
      });
  });

  document.addEventListener('click', function (e) {
    var incBtn = e.target.closest('[data-cart-qty-increase]');
    var decBtn = e.target.closest('[data-cart-qty-decrease]');
    var removeBtn = e.target.closest('[data-cart-line-remove]');
    if (!incBtn && !decBtn && !removeBtn) return;
    var line = e.target.closest('[data-cart-line]');
    if (!line) return;
    var key = line.getAttribute('data-cart-line');
    var qtyEl = line.querySelector('.cart-line-qty span');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty = qty;
    if (incBtn) newQty = qty + 1;
    if (decBtn) newQty = Math.max(0, qty - 1);
    if (removeBtn) newQty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: newQty }),
    })
      .then(function (r) { return r.json(); })
      .then(renderCartDrawer)
      .catch(function () {});
  });

  // Initial cart count on load
  refreshCartUI();

  /* ---------- Product gallery + variant + quantity + tabs (product page) ---------- */
  var productRoot = document.querySelector('[data-product-root]');
  if (productRoot) {
    var mainImage = productRoot.querySelector('[data-product-main-image]');
    productRoot.querySelectorAll('[data-product-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-full-src');
        var alt = thumb.getAttribute('data-full-alt') || '';
        if (mainImage && src) {
          mainImage.style.opacity = 0;
          setTimeout(function () {
            mainImage.src = src;
            mainImage.alt = alt;
            mainImage.style.opacity = 1;
          }, 120);
        }
        productRoot.querySelectorAll('[data-product-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var qtyInput = productRoot.querySelector('[data-qty-input]');
    var qtyInc = productRoot.querySelector('[data-qty-increase]');
    var qtyDec = productRoot.querySelector('[data-qty-decrease]');
    if (qtyInc && qtyInput) qtyInc.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + 1); });
    if (qtyDec && qtyInput) qtyDec.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });

    var tabButtons = productRoot.querySelectorAll('[data-tab-trigger]');
    var tabPanels = productRoot.querySelectorAll('[data-tab-panel]');
    tabButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = btn.getAttribute('data-tab-trigger');
        tabButtons.forEach(function (b) { b.classList.toggle('is-active', b === btn); });
        tabPanels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === target); });
      });
    });

    // Variant option swatches -> update hidden variant id input
    var variantInput = productRoot.querySelector('[data-variant-id-input]');
    var variantData = productRoot.querySelector('[data-variant-json]');
    var variants = [];
    try { variants = JSON.parse(variantData ? variantData.textContent : '[]'); } catch (e) {}
    var optionGroups = productRoot.querySelectorAll('[data-option-index]');
    function currentSelection() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.is-selected');
        selected.push(active ? active.getAttribute('data-value') : null);
      });
      return selected;
    }
    function findVariant(selection) {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selection[i]; });
      });
    }
    function updatePriceDisplay(variant) {
      var priceEl = productRoot.querySelector('[data-product-price]');
      if (priceEl && variant) {
        priceEl.textContent = formatMoney(variant.price);
      }
      var submitBtn = productRoot.querySelector('[data-product-form] [type="submit"]');
      if (submitBtn) {
        if (variant && variant.available) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.getAttribute('data-add-text') || 'Add to Bag';
        } else {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sold Out';
        }
      }
    }
    optionGroups.forEach(function (group) {
      group.querySelectorAll('[data-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          if (btn.disabled) return;
          group.querySelectorAll('[data-value]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          var selection = currentSelection();
          var match = findVariant(selection);
          if (match && variantInput) {
            variantInput.value = match.id;
            updatePriceDisplay(match);
          }
        });
      });
    });
  }

  /* ---------- Collection facets toggle (mobile) ---------- */
  var filterToggle = document.querySelector('[data-filter-toggle]');
  var facets = document.querySelector('[data-facets]');
  if (filterToggle && facets) {
    filterToggle.addEventListener('click', function () { facets.classList.toggle('is-open'); });
  }
  var sortSelect = document.querySelector('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

  /* ---------- Newsletter (Shopify customer form handles submit natively) ---------- */
  document.querySelectorAll('[data-newsletter-form]').forEach(function (form) {
    form.addEventListener('submit', function () {
      var msg = form.querySelector('[data-newsletter-message]');
      if (msg) {
        msg.textContent = 'Thank you for subscribing.';
        msg.classList.add('is-success');
      }
    });
  });
})();
